export const heartRunnerListState = {
    isLoading: false,
    heartRunnerList: [],
    errorNumber: 0,
    errorMessage: '',
    messageLabel: '',    
    statusCode:'',
    countryList : [],
    regionList:[],
    permissionList:[]
} 